export default "__VITE_ASSET__DGDi7PKx__"